import React from 'react';
import NavigationBar from '../NavigationBar';
import { Redirect } from 'react-router-dom';
import RecuperarPanel from '../RecuperarPanel';
import utils from '../../utils/utils.js';

class RecuperarPass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
      mounted: false,
      userData: null,
      userId: null,
      userFullData: null,
    };
    this.updateUserData = this.updateUserData.bind(this);
  }

  updateUserData(userD) {
    if (userD?.data?.user?.id) {
      this.setState({
        loggedIn: userD.data.success,
        userFullData: userD.data,
        userId: userD.data.user.id,
      });
      console.log(this.state.userFullData);
    }
  }

  componentDidMount() {
    try {
      let userData = utils.getUserInfo();
      this.setState(() => {
        return {
          mounted: true,
          userData: userData,
        };
      });
    } catch (error) {
      console.error('Error getting user info:', error);
      // Asegurar que el componente se monte incluso si hay error
      this.setState({
        mounted: true,
        userData: null,
      });
    }
  }

  render() {
    // Si el usuario ya está logueado, redirigir
    if (this.state.mounted && this.state.userFullData !== null) {
      console.log('mounted and logged');
      const userId = this.state.userId || (this.state.userFullData?.user?.id) || '';
      return (
        <Redirect
          to={{
            pathname: '/',
            search: '?userId=' + userId,
            state: this.state,
          }}
        />
      );
    }

    // Si el componente está montado pero el usuario no está logueado, mostrar el panel de recuperación
    if (this.state.mounted) {
      console.log('mounted ', this.state.mounted);
      return (
        <div>
          <NavigationBar isLogged={false} userData={this.state.userData} />
          <RecuperarPanel updateUserDataFunc={this.updateUserData} />
        </div>
      );
    }

    // Estado inicial: mostrando carga
    console.log('loading');
    return (
      <div>
        <NavigationBar isLogged={this.props.isLogged} userData={this.state.userData} />
        <div id="loading">Cargando...</div>
      </div>
    );
  }
}

export default RecuperarPass;
